export default __webpack_public_path__ + "tab4_mobile982161.mp4";